export const siteConfig = {
  title: 'Full Stack Data Science',
  description:
    'Full-stack data science combines data wrangling, analysis, modeling with web development skills to build and deploy data-driven applications.  This role bridges the gap between data science and software engineering.',
  /** Without additional '/' on the end, e.g. https://fullstackdatascience.com */
  url: 'https://fullstackdatascience.com',
  seo: {
    defaultTitle: 'FSDS - Fullstack Data Science',
    defaultDescription:
      'Khám phá các khóa học toàn diện về Full Stack Data Science, bao gồm MLE, MLOps, CV Engineering và NLP Engineering. Làm chủ các giải pháp khoa học dữ liệu toàn diện từ đầu đến cuối với các khóa học thực hành về học máy và vận hành mô hình AI.',
    defaultKeywords: 'data science, machine learning, fullstack, FSDS, AI, MLOps, CV Engineering, NLP Engineering',
    defaultAuthor: 'FSDS Team',
    defaultLocale: 'vi_VN',
    twitterHandle: '@FSDS_VN',
    ogImageWidth: 1200,
    ogImageHeight: 630,
    themeColor: '#3b82f6',
  },
}
